'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleButton = (0, _react.memo)(function (_ref) {
	var active = _ref.active,
	    label = _ref.label,
	    onToggle = _ref.onToggle,
	    disabled = _ref.disabled,
	    className = _ref.className;


	var onClickButton = function onClickButton() {
		onToggle({ active: !active });
	};

	return _react2.default.createElement(
		'button',
		{
			disabled: disabled,
			className: (0, _classnames2.default)('bnc_field', 'bnc_field_toggle-button', className, {
				active: active
			}),
			onClick: onClickButton
		},
		label
	);
});

ToggleButton.defaultProps = {
	disabled: false,
	label: '',
	active: false,
	className: ''
};

ToggleButton.propTypes = {
	onToggle: _propTypes2.default.func,
	active: _propTypes2.default.bool,
	label: _utils.StringOrReact,
	disabled: _propTypes2.default.bool,
	className: _propTypes2.default.string
};

exports.default = ToggleButton;